/**
 * @generated SignedSource<<88e4d10707b940639a53c51558fac41a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CloudProvider = "AWS" | "Azure" | "GCP" | "Kubernetes" | "TencentCloud" | "%future added value";
export type IdentityProviderType = "AWS" | "Azure" | "GCP" | "SAML" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CloudOrganizationCard_organization$data = {
  readonly idpNamespace: string;
  readonly idpType: IdentityProviderType;
  readonly key: string;
  readonly name: string;
  readonly provider: CloudProvider;
  readonly syncOptions: {
    readonly syncGroups: boolean;
    readonly syncResourceViewerRoles: boolean;
  };
  readonly " $fragmentType": "CloudOrganizationCard_organization";
};
export type CloudOrganizationCard_organization$key = {
  readonly " $data"?: CloudOrganizationCard_organization$data;
  readonly " $fragmentSpreads": FragmentRefs<"CloudOrganizationCard_organization">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CloudOrganizationCard_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "idpNamespace",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "idpType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "provider",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SyncOptions",
      "kind": "LinkedField",
      "name": "syncOptions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "syncGroups",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "syncResourceViewerRoles",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CloudOrganization",
  "abstractKey": null
};

(node as any).hash = "dd80d864708577d9a2ca6cb712ad4d53";

export default node;
